import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '../guards/authGuard';

// Lazy load order pages
const MaintenanceManagement = lazy(() => import('../pages/dashboard/MaintenanceManagement'));


const maintenanceRoutes = {
  path: 'maintenance',
  element: (
    <AuthGuard>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <MaintenanceManagement />
    }
    
  ]
};

export default maintenanceRoutes;